import { useLocation, useNavigate, useParams } from "react-router-dom";
import Usuarios from "../../page/usuarios/Usuarios";
import { authContext } from "../../../../context/auth/AuthContext";
import { useContext, useEffect, useState } from "react";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const UsuariosController = () => {
  const location = useLocation();
  const getParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;
  const [filter, setFilter] = useState({
    ["filter[provincia]"]: "Córdoba",
    //["filter[fecha]"]: format(new Date(), "yyyy-M-dd").toString(), //FullMonth(new Date()),
    sort: "-id",
    per_page: 50,
  });
  const [provincias, setProvincias] = useState(null);
  const [usuarios, setUsuarios] = useState(null);
  const [loading, setLoading] = useState(false);
  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "status": {
        console.log(value);

        let formData = new FormData();
        formData.append("_method", "PUT");
        formData.append("id", value.usuario.id);

        /*Evento*/
        formData.append("status_id", value.status);

        const response = await RestPrivateAntesala({
          url: `/usuarios/${value.usuario.id}`,
          formData: formData,
          method: "post",
          setLoading: setLoading,
        });

        //Error
        if (response.status == 201 || response.status == 200) {
          controller = new AbortController();
          const signal = AbortController.signal;
          fetch(setUsuarios, filter, "/usuarios", signal);
          return Alerts({
            msg: "Alert",
            title: response.data.msg,
            code: "401",
            type: "success",
          });
        } else {
          if (typeof response.data.msg === "string") {
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
          }

          Object.keys(response.data.msg).map((key) => {
            return Alerts({
              msg: "Alert",
              title: response.data.msg[key][0],
              code: "401",
              type: "error",
            });
          });
        }
      } break;
      case "añadir-usuario":
        {
          return navigate("/dashboard/usuarios/nuevo");
        }
        break;
      case "editar-usuario":
        {
          return navigate("/dashboard/usuarios/" + value);
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[nombre]"]: e.target.value,
          };

          setFilter({ ...params });

          return fetch(setUsuarios, params, "/usuarios", signal);
        }
        break;
      case "":
        {
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    let params = {
      ...filter,
    };

    if (getParams.get("tipo")) {
      params = {
        ...params,
        ["filter[tipos.id]"]: getParams.get("tipo"),
      };

      setFilter({ ...params })
    }

    fetch(setUsuarios, params, "/usuarios");
  }, [location]);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  return (
    <Usuarios
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      data={usuarios ?? { data: [], links: [] }}
      setData={setUsuarios}
      onClick={onClick}
      onChange={onChange}
      provincias={provincias ?? []}
      navigate={navigate}
      user={data}
      setLoading={setLoading}
    />
  );
};

export default UsuariosController;
